var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgFile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 3.75C4.875 3.54289 5.04289 3.375 5.25 3.375H13.125V8.25C13.125 8.87132 13.6287 9.375 14.25 9.375H19.125V20.25C19.125 20.4571 18.9571 20.625 18.75 20.625H5.25C5.04289 20.625 4.875 20.4571 4.875 20.25V3.75ZM18.5947 8.625L16.2348 6.26517L13.875 3.90533V8.25C13.875 8.45711 14.0429 8.625 14.25 8.625H18.5947ZM5.25 2.625C4.62868 2.625 4.125 3.12868 4.125 3.75V20.25C4.125 20.8713 4.62868 21.375 5.25 21.375H18.75C19.3713 21.375 19.875 20.8713 19.875 20.25V9.31066C19.875 9.01229 19.7565 8.72614 19.5455 8.51516L16.7652 5.73483L13.9848 2.9545C13.7739 2.74353 13.4877 2.625 13.1893 2.625H5.25Z",
    fill: "currentColor"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgFile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/file.03759a8d938bf2dc4f69bf01f237f1d5.svg";